import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import BestSellerRanking from '../../../components/Seller/Items/BestsellerRanking'
import { setErrorBoundaryError, fetchSePaginationBestsellers } from '../../../actions'
import { checkSeCookie } from '../helper'

const setNotFound = (message = '發生錯誤') => {
  return setErrorBoundaryError({ message })
}

const mapStateToProps = (state, ownProps) => {
  return {
    page: state.page
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = {
    setNotFound,
    fetchSePaginationBestsellers
  }

  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

// Overrides default preFetcher in app.server.js
BestSellerRanking.preFetcher = ({ store, req, res }) => {
  // Checking cookie `se` for verifying its existance, redirect to error page if not
  const cookies = req.cookies
  const { error } = checkSeCookie(cookies)
  if (error) {
    return Promise.reject(error)
  }

  return Promise.resolve()
}

BestSellerRanking.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const MappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(BestSellerRanking)

export default MappedComponent
